import React from "react";
import Map from "@/components/maps/Map"; // Import Map component

const Location = ({ selectedTour }) => {
  return (
    <div className="bg-light-200 card-bg-light mb-4" id="location">
      <h5 className="fs-18 mb-3">Địa điểm khởi hành</h5>
      <div className="d-flex align-items-center flex-wrap">
            <p className="fs-14 mb-2 me-3 pe-3">
              <i className="isax isax-location5 me-2"></i>
              {selectedTour.departureLocation}
              <a
                href="#location"
                className="link-primary text-decoration-underline fw-medium ms-2"
              >
                View Location
              </a>
            </p>
          </div>
      <Map initialLocation={selectedTour.departureLocation} />
    </div>
  );
};

export default Location;